export const ZoomTabMapping = {
  currentMeeting: 1,
  pastMeeting: 2,
  scheduleMeeting: 3,
};
